import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

function Rating({ value = 0, text = "" }) {
  const normalized = Number(value) || 0;

  const renderStar = (index) => {
    const threshold = index + 1;
    if (normalized >= threshold) {
      return <FaStar className="h-4 w-4 text-amber-400" />;
    }
    if (normalized >= threshold - 0.5) {
      return <FaStarHalfAlt className="h-4 w-4 text-amber-400" />;
    }
    return <FaRegStar className="h-4 w-4 text-amber-400" />;
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <div className="flex items-center gap-1">
        {[0, 1, 2, 3, 4].map((index) => (
          <span key={index} className="inline-flex items-center">
            {renderStar(index)}
          </span>
        ))}
      </div>
      {text ? <span className="text-sm font-medium text-slate-700">{text}</span> : null}
    </div>
  );
}

export default Rating;
